import { useAction } from "@/hooks/shared";
import { getCompanyByIdHandler } from "@/services";

export const useCompany = () => useAction(getCompanyByIdHandler);
